import { removePhoneMask } from './normalizer'
import { PHONE_CONSTRAINTS, PHONE_MASKED_REGEX } from './regex'

export const phoneRules = {
	required: 'Укажите номер телефона',
	validate: (value: string) => {
		const digits = removePhoneMask(value).replace(/\D/g, '')
		if (digits.length !== PHONE_CONSTRAINTS.DIGITS_LENGTH) {
			return 'Введите полный номер телефона'
		}
		if (!PHONE_MASKED_REGEX.test(value)) {
			return 'Укажите в формате +7 (9XX) XXX-XX-XX'
		}
		return true
	}
} as const

export const phoneRulesOptional = {
	validate: (value: string) => {
		if (!value || value.trim() === '') return true
		const digits = removePhoneMask(value).replace(/\D/g, '')
		if (digits.length !== PHONE_CONSTRAINTS.DIGITS_LENGTH) {
			return 'Введите полный номер телефона'
		}
		if (!PHONE_MASKED_REGEX.test(value)) {
			return 'Укажите в формате +7 (9XX) XXX-XX-XX'
		}
		return true
	}
} as const
